var _style, _g, _g2, _g3, _path, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFvLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 453 102.4",
    style: {
      enableBackground: "new 0 0 453 102.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#52C6DA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.4,39.9l-1.3-1c6.8-8.2,17.5-12.1,28.2-10.2l-0.3,1.6C259.9,28.5,249.9,32.2,243.4,39.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.9,87.4c-8.6,0-16.8-3.8-22.4-10.3l1.2-1.1c5.3,6.2,13.1,9.8,21.2,9.8c7.8,0,14.3-5.2,18.3-9.5l1.2,1.1 C280.2,82,273.4,87.4,264.9,87.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15,44.7 35.5,44.7 35.5,49.4 20.3,49.4 20.3,57.2 35.2,57.2 35.2,61.8 20.3,61.8 20.3,74.7 15,74.7  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,49.4h-7.2v9.5h7.2c3,0,5.1-1.9,5.1-4.8S62.7,49.4,59.7,49.4 M57.7,63.5h-5.2v11.2h-5.3v-30h13.2 c5.9,0,9.8,3.9,9.8,9.4c0,5.4-3.5,8.2-7.1,8.8l7.3,11.8h-6.1L57.7,63.5z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82.5,44.7 103,44.7 103,49.4 87.7,49.4 87.7,57.2 102.7,57.2 102.7,61.8 87.7,61.8 87.7,70.1  103,70.1 103,74.7 82.5,74.7  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 115.4,
    y: 44.7,
    className: "st0",
    width: 5.3,
    height: 30
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.4,44.3c5.8,0,9.7,2.8,12.1,6.3l-4.3,2.4c-1.6-2.2-4.4-4-7.8-4c-5.9,0-10.3,4.5-10.3,10.8 c0,6.3,4.4,10.9,10.3,10.9c3.1,0,5.8-1.4,7.1-2.7v-4.7h-9v-4.6h14.2v11.2c-3,3.3-7.2,5.4-12.4,5.4c-8.7,0-15.7-6.2-15.7-15.6 C132.7,50.4,139.7,44.3,148.4,44.3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "194.1,61.7 178.5,61.7 178.5,74.7 173.2,74.7 173.2,44.7 178.5,44.7 178.5,57 194.1,57 194.1,44.7  199.3,44.7 199.3,74.7 194.1,74.7  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "219.9,49.4 210.8,49.4 210.8,44.7 234.2,44.7 234.2,49.4 225.1,49.4 225.1,74.7 219.9,74.7  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.1,78.3L264.1,78.3c-1.2,0-2.2-0.7-2.6-1.7L249,47.1c-0.6-1.5,0.1-3.1,1.5-3.8c1.5-0.6,3.1,0.1,3.8,1.5 l9.9,23.4l23.1-51.6c0.6-1.4,2.3-2.1,3.8-1.4c1.4,0.6,2.1,2.3,1.4,3.8l-25.8,57.6C266.2,77.6,265.2,78.3,264.1,78.3"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "293.6,45.4 314.2,45.4 314.2,50.1 298.9,50.1 298.9,57.8 313.9,57.8 313.9,62.5 298.9,62.5  298.9,70.8 314.2,70.8 314.2,75.4 293.6,75.4  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339,50.1h-7.2v9.5h7.2c3,0,5.1-1.9,5.1-4.8S342,50.1,339,50.1 M337,64.2h-5.2v11.2h-5.3v-30h13.2 c5.9,0,9.8,3.9,9.8,9.4c0,5.4-3.5,8.2-7.1,8.8l7.3,11.8h-6.1L337,64.2z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.8,
    y: 45.4,
    className: "st0",
    width: 5.3,
    height: 30
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "380.4,45.4 400.9,45.4 400.9,50.1 385.6,50.1 385.6,57.8 400.6,57.8 400.6,62.5 385.6,62.5  385.6,75.4 380.4,75.4  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "421.1,63 409.5,45.4 415.5,45.4 423.8,58.3 432,45.4 438,45.4 426.4,63 426.4,75.4 421.1,75.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvLogoLight);
export default __webpack_public_path__ + "static/media/fv_logo_light.4c55d4cfe298653823832c809705cc0a.svg";
export { ForwardRef as ReactComponent };